import { useIntegrations } from '@/lib/integrationsApi';
import { IntegrationCard } from './IntegrationCard';

export default function IntegrationsPage() {
  const { data, isLoading, isError } = useIntegrations();

  return (
    <div className="min-h-screen bg-muted">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <header className="mb-8">
          <h1 className="text-2xl font-semibold leading-[1.3]">Integrations</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Connect third-party services used by the platform.
          </p>
        </header>

        {isLoading && <p className="text-sm text-muted-foreground">Loading integrations…</p>}
        {isError && <p className="text-sm text-destructive">Couldn't load integrations.</p>}

        {data && (
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {data.integrations.map((i) => (
              <IntegrationCard key={i.type} integration={i} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
